import requestor from "shared/service/requestor";

export default class SurveyInstanceApi {
  one = ({ courseId, lessonId }, id) =>
    requestor.get("/course/survey_instance_one", {
      course_id: courseId,
      lesson_id: lessonId,
      id: id,
    });

  vote = {
    all: ({ courseId, lessonId }, surveyId = null, clientId = null) =>
      requestor.get("/course/survey_instance_vote_all", {
        course_id: courseId,
        lesson_id: lessonId,
        survey_id: surveyId,
        client_id: clientId,
      }),
    one: ({ courseId, lessonId }, id) =>
      requestor.get("/course/survey_instance_vote_one", { course_id: courseId, lesson_id: lessonId, id: id }),
  };
}
